/*
  SIJL verwijsprogramma (B2B)
  Hoort bij sections/sijl-verwijsprogramma.liquid (in het bestelportaal), snippets/sijl-verwijs-portaal.liquid
  en sections/sijl-verwijs-aanmelding.liquid (op /pages/wholesale).

  In het bestelportaal:
  - de eigen code of link kopiëren, delen via het deelmenu van de telefoon, per mail of WhatsApp;
  - staat een kortingscode al in de winkelwagen, dan wordt 'Toepassen' 'Staat in je winkelwagen'.

  Bij de aanmelding:
  - de code uit de link lezen (?verwijs=CODE) en bewaren zolang het tabblad open is;
  - de welkomstmelding boven het formulier tonen;
  - de code invullen in het veld 'Verwijscode' van het Forms-formulier. Dat formulier staat in een
    afgeschermd blok (shadow DOM) en wordt pas na het laden van de pagina getekend; we zoeken het veld
    daarom een tijdje opnieuw tot het er is.
*/
(function () {
  'use strict';

  if (window.sijlVerwijsprogramma) return;
  window.sijlVerwijsprogramma = true;

  var OPSLAG = 'sijl-verwijscode';
  var ZOEKEN_MAX = 40; /* x 500 ms = 20 seconden */

  function schoon(code) {
    return String(code || '')
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, '')
      .slice(0, 24);
  }

  function lees(sleutel) {
    try {
      return window.sessionStorage.getItem(sleutel);
    } catch (e) {
      return null;
    }
  }

  function bewaar(sleutel, waarde) {
    try {
      window.sessionStorage.setItem(sleutel, waarde);
    } catch (e) {
      /* privévenster of opslag uit: dan onthouden we het niet */
    }
  }

  function wortel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- Kopiëren en delen (bestelportaal) ---------- */

  function kopieer(tekst) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(tekst);
    }
    return new Promise(function (gelukt, mislukt) {
      var veld = document.createElement('textarea');
      veld.value = tekst;
      veld.setAttribute('readonly', '');
      veld.style.position = 'fixed';
      veld.style.top = '0';
      veld.style.opacity = '0';
      document.body.appendChild(veld);
      veld.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(veld);
      if (ok) gelukt();
      else mislukt();
    });
  }

  function portaal(blok) {
    if (blok.hasAttribute('data-svp-klaar')) return;
    blok.setAttribute('data-svp-klaar', '');

    var melding = blok.querySelector('[data-svp-melding]');
    var timer = null;

    function meld(tekst, fout) {
      if (!melding) return;
      melding.textContent = tekst;
      melding.classList.toggle('is-fout', !!fout);
      clearTimeout(timer);
      timer = setTimeout(function () {
        melding.textContent = '';
      }, 5000);
    }

    blok.querySelectorAll('[data-svp-kopieer]').forEach(function (knop) {
      var label = knop.textContent;
      knop.addEventListener('click', function () {
        var wat = knop.getAttribute('data-svp-wat') || 'Tekst';
        kopieer(knop.getAttribute('data-svp-kopieer') || '').then(
          function () {
            meld(wat + ' gekopieerd. Plak hem in een mail of bericht.');
            knop.textContent = 'Gekopieerd';
            setTimeout(function () {
              knop.textContent = label;
            }, 2000);
          },
          function () {
            meld('Kopiëren lukte niet. Selecteer de tekst en kopieer hem zelf.', true);
          }
        );
      });
    });

    var veld = blok.querySelector('[data-svp-linkveld]');
    if (veld) {
      veld.addEventListener('focus', function () {
        veld.select();
      });
    }

    var onderwerp = blok.getAttribute('data-onderwerp') || '';
    var bericht = blok.getAttribute('data-bericht') || '';
    var mail = blok.querySelector('[data-svp-mail]');
    var app = blok.querySelector('[data-svp-whatsapp]');
    var deel = blok.querySelector('[data-svp-deel]');

    if (mail) {
      mail.href = 'mailto:?subject=' + encodeURIComponent(onderwerp) + '&body=' + encodeURIComponent(bericht);
    }
    if (app) {
      app.href = 'https://wa.me/?text=' + encodeURIComponent(bericht);
    }

    /* Op een telefoon het eigen deelmenu (daar zitten mail en WhatsApp al in) */
    var telefoon = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (deel && navigator.share && telefoon) {
      deel.hidden = false;
      if (mail) mail.hidden = true;
      if (app) app.hidden = true;
      deel.addEventListener('click', function () {
        navigator.share({ title: onderwerp, text: bericht }).catch(function () {
          /* gebruiker sloot het deelmenu */
        });
      });
    }
  }

  /* Staat een code uit het verwijsprogramma al in de winkelwagen? */
  function toegepast() {
    var knoppen = document.querySelectorAll('[data-svp-toepassen]');
    if (!knoppen.length || !window.fetch) return;

    fetch(wortel() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (antwoord) {
        return antwoord.ok ? antwoord.json() : null;
      })
      .then(function (wagen) {
        if (!wagen) return;
        var codes = [];
        (wagen.discount_codes || []).forEach(function (korting) {
          if (korting && korting.code) codes.push(String(korting.code).toUpperCase());
        });
        (wagen.cart_level_discount_applications || []).forEach(function (korting) {
          if (korting && korting.type === 'discount_code' && korting.title) {
            codes.push(String(korting.title).toUpperCase());
          }
        });
        if (!codes.length) return;

        knoppen.forEach(function (knop) {
          var code = String(knop.getAttribute('data-svp-toepassen') || '').toUpperCase();
          if (!code || codes.indexOf(code) === -1) return;
          var klaar = document.createElement('span');
          klaar.className = 'svp-toegepast';
          klaar.textContent = 'Staat in je winkelwagen';
          knop.parentNode.replaceChild(klaar, knop);
        });
      })
      .catch(function () {
        /* geen winkelwagen op te halen: de knop blijft gewoon staan */
      });
  }

  /* ---------- Aanmelden met een verwijscode (/pages/wholesale) ---------- */

  function tekstVan(veld, basis) {
    var teksten = [veld.name, veld.id, veld.placeholder, veld.getAttribute('aria-label')];
    if (veld.labels) {
      for (var i = 0; i < veld.labels.length; i++) teksten.push(veld.labels[i].textContent);
    }
    var ids = (veld.getAttribute('aria-labelledby') || '').split(/\s+/);
    ids.forEach(function (id) {
      if (!id || !basis.getElementById) return;
      var el = basis.getElementById(id);
      if (el) teksten.push(el.textContent);
    });
    return teksten.join(' ').toLowerCase();
  }

  function zoekIn(basis, sleutel, diepte) {
    if (!basis || diepte > 4) return null;
    var velden = basis.querySelectorAll('input, textarea');
    for (var i = 0; i < velden.length; i++) {
      var type = (velden[i].getAttribute('type') || 'text').toLowerCase();
      if (['hidden', 'checkbox', 'radio', 'submit', 'button'].indexOf(type) !== -1) continue;
      if (tekstVan(velden[i], basis).indexOf(sleutel) !== -1) return velden[i];
    }
    var alles = basis.querySelectorAll('*');
    for (var j = 0; j < alles.length; j++) {
      if (alles[j].shadowRoot) {
        var gevonden = zoekIn(alles[j].shadowRoot, sleutel, diepte + 1);
        if (gevonden) return gevonden;
      }
    }
    return null;
  }

  function zoekVeld(sleutel) {
    var formulieren = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < formulieren.length; i++) {
      var gevonden = zoekIn(formulieren[i].shadowRoot || formulieren[i], sleutel, 0);
      if (gevonden) return gevonden;
    }
    return null;
  }

  /* Waarde zetten zoals een bezoeker dat doet, zodat het formulier het ook echt meestuurt */
  function vulIn(veld, waarde) {
    var soort = veld.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement : window.HTMLInputElement;
    var eigenschap = soort && Object.getOwnPropertyDescriptor(soort.prototype, 'value');
    if (eigenschap && eigenschap.set) eigenschap.set.call(veld, waarde);
    else veld.value = waarde;
    veld.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    veld.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function aanmelding(blok) {
    if (blok.hasAttribute('data-svp-klaar')) return;
    blok.setAttribute('data-svp-klaar', '');

    var uitLink = '';
    try {
      uitLink = schoon(new URLSearchParams(window.location.search).get('verwijs'));
    } catch (e) {
      uitLink = '';
    }
    if (uitLink.length >= 4) bewaar(OPSLAG, uitLink);

    var code = uitLink.length >= 4 ? uitLink : schoon(lees(OPSLAG));
    if (code.length < 4) code = schoon(blok.getAttribute('data-voorbeeld'));
    if (code.length < 4) return;

    var tekst = blok.querySelector('[data-svp-tekst]');
    if (tekst) {
      var delen = (tekst.getAttribute('data-sjabloon') || '[code]').split('[code]');
      tekst.textContent = '';
      delen.forEach(function (deel, i) {
        if (i > 0) {
          var sterk = document.createElement('strong');
          sterk.textContent = code;
          tekst.appendChild(sterk);
        }
        tekst.appendChild(document.createTextNode(deel));
      });
    }
    blok.hidden = false;

    var status = blok.querySelector('[data-svp-status]');
    function zet(naam) {
      if (status) status.textContent = status.getAttribute(naam) || '';
    }
    zet('data-zelf');

    var sleutel = (blok.getAttribute('data-veld') || 'verwijs').toLowerCase();
    var pogingen = 0;

    (function probeer() {
      var veld = zoekVeld(sleutel);
      if (veld) {
        var huidig = schoon(veld.value);
        if (!huidig || huidig === code) {
          if (huidig !== code) vulIn(veld, code);
          zet('data-ingevuld');
        }
        return;
      }
      pogingen += 1;
      if (pogingen < ZOEKEN_MAX) setTimeout(probeer, 500);
    })();
  }

  /* ---------- Start ---------- */

  function start(basis) {
    (basis || document).querySelectorAll('[data-svp]').forEach(portaal);
    (basis || document).querySelectorAll('[data-svp-aanmelding]').forEach(aanmelding);
    toegepast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
    });
  } else {
    start();
  }

  /* In de editor worden secties opnieuw getekend als je iets aanpast */
  document.addEventListener('shopify:section:load', function (e) {
    start(e.target);
  });
})();
